<script lang="ts">
	import { page } from '$app/stores';
	import { PUBLIC_IMAGES_API } from '$env/static/public';
	import __ from '$lib/stores/TranslationStore';
	import { toWebp } from '$lib/utils/helpers/convert';
	import Breadcrumbs from '../Global/Breadcrumbs/Breadcrumbs.svelte';
	import ScrollButton from '../Global/ScrollButton.svelte';
	import ArticleContent from './ArticleContent.svelte';
	import RichTextPreview from './RichTextPreview/RichTextPreview.svelte';
	import SocialShare from './SocialShare.svelte';
	import Tag from './Tags/Tag.svelte';

	export let article: Article;
	let className: string | null = null;
	export { className as class };

	let mainCategory: Category | undefined;
	$: mainCategory = article.category?.main;

	const url = PUBLIC_IMAGES_API;

	const filename = toWebp(article.cover_name);
</script>

<!-- Tracking pixel -->
<img
	src="{$page.url.origin}/api/analytics/{article.slug}/tr.gif"
	width="1"
	height="1"
	alt="analytics"
/>
<article class={`text-dark ${className}`} data-sveltekit-preload-data="off" data-sveltekit-reload>
	<Breadcrumbs
		class="text-[10px] md:text-sm"
		arrowClass="h-3 w-4 stroke-dark stroke-[10px]"
		crumbs={[
			{ label: $__('Artigos'), url: '/artigos' },
			...(mainCategory
				? [{ label: mainCategory.label, url: `/artigos/${mainCategory.slug}` }]
				: []),
			{ label: article.category.label }
		]}
	/>
	<header class="flex flex-col space-y-5">
		<figure class="mb-4 flex h-auto justify-center">
			<img
				id="article-cover"
				class="aspect-[16/9] w-full object-cover"
				src="{url}/900/{filename}"
				role="presentation"
				srcset="
					{url}/200/{filename} 200w,
					{url}/300/{filename} 300w,
					{url}/400/{filename} 400w,
					{url}/800/{filename} 800w
				"
				sizes="
					(max-width: 640px) 200px,
					(max-width: 768px) 300px,
					(max-width: 1024px) 400px,
					(max-width: 1280px) 800px,
					(max-width: 1536px) 900px,
					900px
				"
				alt={article.cover_alt || article.title}
			/>
		</figure>
		<section class="space-y-4 lg:order-first">
			<h1 class="text-2xl font-bold leading-normal text-slate md:text-4xl/snug lg:text-5xl/snug">
				{article.title}
			</h1>
			<div class="text-left text-sm font-normal leading-5 md:text-lg">
				<RichTextPreview content={article.introduction} />
			</div>
			<div class="flex flex-col justify-between gap-4 pb-8 md:flex-row md:items-center">
				<p class="text-xs">
					<span class="published_at">{article.published_at}</span> •
					<span class="read_duration">{article.read_duration} min</span>
				</p>
				<SocialShare class="md:py-0">
					<p slot="header" class="self-center text-sm text-neutral-400 md:hidden lg:self-auto">
						{$__('Gostou do que leu? Partilhe!')}
					</p>
				</SocialShare>
			</div>
		</section>
	</header>
	<main class="text-left font-robotoslab text-lg md:text-xl">
		<ArticleContent content={article.content} />
	</main>
	<footer>
		<SocialShare class="mb-5 hidden items-center justify-center md:flex">
			<p
				slot="header"
				class="w-full self-center border-b-2 pb-5 text-center text-sm text-primary lg:self-auto"
			>
				{$__('Gostou do que leu? Partilhe!')}
			</p>
		</SocialShare>
		<ul class="flex flex-wrap gap-2">
			{#each article.tags as tag}
				<Tag {tag} />
			{/each}
		</ul>
	</footer>
	<ScrollButton />
</article>
